<template>
    <v-select  v-model="edrpou"
               @search="onSearchedrpou"
               @input="check"

               label="edrpou"
               :filterable="false"
               class="style-chooser"
               :class="{ 't-danger': !valid }"
               :options=multi_edrpoг_filtered  >
        <template slot="no-options">
            Починайте вводити номер ЄДРПОУ
        </template>
        <template slot="option" slot-scope="option">
            <div class="d-center">
                {{ option.edrpou }}
                <small >{{option.name}}</small>
            </div>
        </template>
    </v-select>
</template>

<script>
import vSelect from 'vue-select'

export default {
name: "edrpou",


    props :{
        row : {
            type : Object,
            required: true
        }
    },

    components : {
        vSelect
    },

    data() {
        return {
            multi_edrpou: [],
        }
    },



    methods: {
        onSearchedrpou(search, loading) {
            if(search.length > 3) {
                loading(true);
                this.searchedrpou(loading, search);
            }
        },

        async searchedrpou(loading, search)  {
            let edrp = [];
            this.multi_edrpou = [];
            edrp.push(search);
            
            await api.post('/organizations/1c/getOrgbyErdpu',{codes : edrp}).then(({data}) => {
                loading(false);
                if(data.status == "operation_success") {
                    this.multi_edrpou = data.data;
                }
            }).catch(err => {
                loading(false);
            });
        },

        isNumber(evt) {
            let keysAllowed = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', ' ', ';'];
            let keyPressed = evt.key;
            console.log(evt.key)
            if (!keysAllowed.includes(keyPressed)) {
                evt.preventDefault()
            }
        },

        async check(val) {
            
            if (val == null) {
                this.row.valid = false;
                return;
            }
            
            let arr0 = val.edrpou.split(';');
            let arr = arr0.map(x => x.replace(/\s+/g, ''));
            this.row.valid = arr.every((v) => {
                return v.length == 8 || v.length == 10
            });
            
            if (this.row.valid) {
                let code = val.edrpou.replace(/\s+/g, '');
                await api.post('/counterparty/check/' + code,).then(({data}) => {
                    if (data.status == "operation_success") {
                        this.row.valid = data.message;
                        if (!this.row.valid) {
                            EventBus.$emit('show_toast', {
                                err: 'Контрагент знаходиться в чорному списку, за роз\'ясненнями звертатися до керівництва ФЕБ',
                                type: "danger",
                                title: data.html
                            })
                        }
                    }
                }).catch(err => {
                    EventBus.$emit('show_toast', {err: err.message, type: "danger", title: err.name})
                    this.row.valid = false;
                });
            }
        }
    },

    watch : {
        edrpou:  function (val) {
            let ch_val =  {
                'edrpou' : val
            }
            this.check(ch_val);
        },
    },

    computed : {

        multi_edrpoг_filtered() {
            if(this.multi_edrpou.length > 0) {
                return this.multi_edrpou.map((element, index) =>{
                   element.key = index
                    return element
                })
            }

            return [];
        },

        valid :{
            set: function (val)  {
             this.worked_doc.valid = val;
           },
            get: function () {
                return this.worked_doc.valid;
            }
        },

        edrpou :{
            set: function (val)  {
                if (val == null) {
                    this.worked_doc.edrpou = '';
                    this.worked_doc.name = '';

                }
                else {
                    if (val.name == ''){
                        this.worked_doc.edrpou = val.edrpou;
                    }
                    else {
                        this.worked_doc.edrpou = val.edrpou;
                        this.worked_doc.name = val.name;
                    }

                }
           },
            get: function () {
                return this.worked_doc.edrpou;
            }
        },
        worked_doc : {
            set: function (val)  {
                this.row = val;
            },
            get: function () {
                return this.row;
            }
        },



    }

}
</script>

<style >
.t-danger .vs__dropdown-toggle
{
    border-color: #d3123e;
}

.style-chooser .vs__dropdown-toggle,
.style-chooser .vs__dropdown-menu {
    /*background: #dfe5fb;*/



}
.vs__search,
.vs__search:focus {
    margin: 0 !important;
}
</style>